import React, { useState } from 'react';
import styled from 'styled-components'; 
import FitgroupChangeBasic from './fitgroupdetail/FitgroupChangeBasic';
import FitgroupChangeInfoMake from './fitgroupdetail/FitgroupChangeInfoMake';
import ChangeTitle from '../../peoplelist/ChangeTitle';
import Modalback from '../../modal/Modalback';
import serverController from '../../../server/serverController';
import { Link, useHistory } from 'react-router-dom';

export default function Fitgroup() {
  const history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const [fitIntroductContent, setFitIntroductContent] = useState('');
  const [screenIndex, setScreenIndex] = useState(0);

  const [fitImg, setFitImg] = useState(null);
  const [fitName, setFitName] = useState('');
  const [fitinfo, setFitinfo] = useState('');
  const [publics, setPublics] = useState(null);

  const callBack = (res) => {
    if (res.success === 1) {
      window.location.reload();
      history.goBack();
      //serverController.getServerData("auth",test);
    } else {
      alert('실패');
    }
  };

  const imageSendCallBack = async (data) => {
    var imagePathArray = [];
    data.data.upload_results.map((value) => {
      imagePathArray.push(value.file_name);
    });

    let serverData = {
      title: fitName,
      description: fitinfo,
      visibility:  'public',
      group_cover_img: imagePathArray.pop(),
    };

    await serverController.generalPostFetchController(
      `groups/`,
      JSON.stringify(serverData),
      callBack,
    );
    isclick = false;
  };

  /*--click block--*/
  var isclick = false;
  const dataSubmit = async () => {
    if (isclick) return;
    isclick = true;
    if (fitImg != null) {
      var formData = new FormData();
      formData.append('file', fitImg);
      formData.append('path', 'group_cover_img/');
      await serverController.updatefilePostFetchController(
        `file`,
        formData,
        imageSendCallBack,
      );
    } else alert('이미지를 선택해주세요');
    // updateNext(1);
  };

  const updateNext = (index) => {
    // 페이지 더 생성되면 숫자 늘려나가기
    if (screenIndex + index == -1 || screenIndex + index > 1) return;
    setScreenIndex(screenIndex + index);
  };

  const Closeclick = () => {
    alert('확인');
    setShowModal(false);
  };

  let renderPageController = () => {
    switch (screenIndex) {
      case 0:
        return (
          <FitgroupChangeBasic
            updateNext={updateNext}
            titname={'모임 이름'}
            fitImg={fitImg}
            setFitImg={setFitImg}
            fitName={fitName}
            setFitName={setFitName}
            placeholder={'ex) 강남구 직장인 다이어터 모임'}
          />
        );
      case 1:
        return (
          <FitgroupChangeInfoMake
            // fitIntroductContent={fitIntroductContent}
            // setFitIntroductContent={setFitIntroductContent}
            updateNext={updateNext}
            infotext={
              '본인 모임에 대한 간단한 소개 및 주의사항 / 가이드라인을 제시해 주세요'
            }
            dataSubmit={dataSubmit}
            fitinfo={fitinfo}
            setFitinfo={setFitinfo}
            publics={publics}
            setPublics={setPublics}
          />
        );
      //  updateNext={updateNext} 넘기는게 중요!!!
    }
  };

  return (
    <Fitgroupinner>
      <ChangeTitle
        title={'모임 만들기'}
        borderbottom={'solid 1px #d5d5d5'}
        setShowModal={setShowModal}
      />
      {renderPageController()}
      <Modalback
        setShowModal={setShowModal}
        showModal={showModal}
        title={'모임 생성 취소'}
        subtitle={'내가 작성한 모임이 취소됩니다. 취소 하시겠어요? '}
        submitClick={Closeclick}
      />
    </Fitgroupinner>
  );
}

const Fitgroupinner = styled.div`
  padding-bottom: calc(100vw * (120 / 375));
`;
